import React, { Component } from 'react';
import { PageNotFound as SharedComponentPageNotFound } from '@chr/navisphereonline-shared-components';
import { Header, Footer } from '@chr/navisphereonline-shared-components';
import { ConfigContext, AuthContext } from '@chr/navisphereonline-shared-components';
import { OnlineTranslationContext } from '@chr/online-shared-ui-localizations';

export interface PageNotFoundProps {
  history: any;
}
export interface PageNotFoundComponentProps {
  history: any;
  translate: (key: string, replaceVariable?: string[]) => string;
}

export class PageNotFoundComponent extends Component<PageNotFoundComponentProps>  {
  static contextType = ConfigContext;
  translate = (key: string, replaceVariable?: string[]) => this.props.translate ? this.props.translate(key, replaceVariable): key;

  onRedirect = () => {
    this.props.history.push('/');
  }

  render() {
    return (
      <React.Fragment>
        <AuthContext.Consumer>
        { (authClient) => <Header appConfig={{...this.context, allowGuests: false}} authClient={authClient} /> }
        </AuthContext.Consumer>
        <div className="container">
          <SharedComponentPageNotFound
              titleText={this.translate("Page Not Found")}
              pageText={this.translate("The page you are trying to access does not exist or cannot be displayed for you.")}
              hasRedirectButton={true}
              redirectButtonText={this.translate("Take me to the C.H. Robinson Online application(s) I have access to")}
              redirect={this.onRedirect}
            />
        </div>
        <Footer />
      </React.Fragment>
    );
  }
};

class PageNotFound extends Component<PageNotFoundProps> {
  render() {
    return (
      <OnlineTranslationContext.Consumer>
        {({translate})=>(
          <PageNotFoundComponent translate={translate} history={this.props.history}/>
        )}
      </OnlineTranslationContext.Consumer>
    )
  }
}

export default PageNotFound;
